var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"2","color":"background"}},[_c('v-card-text',{staticClass:"mt-10",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"primary--text",staticStyle:{"font-size":"4em"}},[_vm._v("404")]),_c('h1',{staticClass:"ma-5"},[_vm._v("العنوان المطلوب غير موجود")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }